import styled from 'vue-styled-components';

// Create a <StyledTitle> Vue component that renders an <h1> which is
// centered, palevioletred and sized at 1.5em
const StyledTitle = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: palevioletred;
`;

// Create a <Wrapper> Vue component that renders a <section> with
// some padding and a papayawhip background
const Wrapper = styled.section`
  padding: 4em;
  background: papayawhip;
`;


export default {
  name: 'skill-jsx-css-in-js',
  data() {
    return {
      type: 'js'
    }
  },
  render() {
    return(
      <StyledTitle>
        <Wrapper>
        Hello World, this is my first styled component!
        </Wrapper>
      </StyledTitle>
    )
  }
}
